import { createReducer, on } from '@ngrx/store';

import * as MerchantActions from './merchant.actions';
import { Merchant } from '../../../core/domain/merchant/merchant';
import { FormMode, IFormMode } from '../../types/IFormMode';

export interface MerchantState {
  isModalOpen: boolean;
  formMode?: IFormMode;
  openedMerchant?: Merchant;

  merchants: Merchant[];
}

export const initialState: MerchantState = {
  isModalOpen: false,
  formMode: undefined,
  openedMerchant: undefined,

  merchants: [],
};

export const merchantReducer = createReducer(
  initialState,

  on(MerchantActions.openMerchantModal, (state, action) => ({
    ...state,
    isModalOpen: true,
    formMode: action.mode,
    openedMerchant: action.merchant || undefined,
  })),
  on(MerchantActions.closeMerchantModal, (state) => ({
    ...state,
    isModalOpen: false,
    formMode: undefined,
    openedMerchant: undefined,
  })),

  on(MerchantActions.loadMerchants, (state, action) => ({
    ...state,
    merchants: action.merchants,
  })),

  on(MerchantActions.createMerchant, (state, action) => ({
    ...state,
    merchants: [...state.merchants, action.merchant],
  })),
  on(MerchantActions.updateMerchant, (state, action) => ({
    ...state,
    merchants: state.merchants.map((merchant) =>
      merchant.id === action.merchant.id ? action.merchant : merchant
    ),
  })),
  on(MerchantActions.deleteMerchant, (state, action) => ({
    ...state,
    merchants: state.merchants.filter(
      (merchant) => merchant.id !== action.merchantId
    ),
  }))
);
